(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos-benefits"] && !Shopify.designMode) return;
  try {
    
/* Toggle CTA label (unchanged) */
document.addEventListener('click', function(e){
  const btn = e.target.closest('.ugc-{{ section.id }} .ugc-btn');
  if(!btn) return;
  if(btn.dataset.toggle === 'true'){
    const def = btn.dataset.labelDefault;
    const act = btn.dataset.labelActive || def;
    btn.textContent = (btn.textContent.trim() === def) ? act : def;
  }
});

/* Click-to-play (no overlays, no arrows, no dots) */
(function(){
  const root = document.querySelector('.ugc-{{ section.id }}');
  if(!root) return;
  const tiles = Array.from(root.querySelectorAll('.ugc-video'));
  const mediaEls = tiles.map(t => t.querySelector('.ugc-video-el'));

  /* Enable YT/Vimeo APIs so postMessage play/pause works when clicking the tile */
  function enableIframeAPI(iframe){
    if(!(iframe && iframe.tagName === 'IFRAME')) return;
    try{
      const src = new URL(iframe.src, window.location.href);
      if(src.hostname.match(/youtube\.com|youtu\.be/)){
        if(!src.searchParams.has('enablejsapi')) src.searchParams.set('enablejsapi', '1');
        iframe.src = src.toString();
      }else if(src.hostname.match(/vimeo\.com/)){
        if(!src.searchParams.has('api')) src.searchParams.set('api', '1');
        iframe.src = src.toString();
      }
    }catch(e){}
  }
  mediaEls.forEach(m => { if(m && m.tagName === 'IFRAME') enableIframeAPI(m); });

  function pauseOthers(except){
    mediaEls.forEach(m=>{
      if(!m || m === except) return;
      const tile = m.closest('.ugc-video');
      if(m.tagName === 'VIDEO'){
        try{ m.pause(); }catch(_){}
      }else if(m.tagName === 'IFRAME'){
        try{
          const src = new URL(m.src, window.location.href);
          if(src.hostname.match(/youtube\.com|youtu\.be/)){
            m.contentWindow.postMessage(JSON.stringify({ event:'command', func:'pauseVideo', args:[] }), '*');
          }else if(src.hostname.match(/vimeo\.com/)){
            m.contentWindow.postMessage(JSON.stringify({ method:'pause' }), '*');
          }
        }catch(_){}
      }
      tile?.classList.remove('is-playing');
    });
  }

  tiles.forEach(tile=>{
    const media = tile.querySelector('.ugc-video-el');
    if(!media) return;

    function playMedia(){
      pauseOthers(media);
      if(media.tagName === 'VIDEO'){
        media.play().catch(()=>{});
      }else{
        try{
          const src = new URL(media.src, window.location.href);
          if(src.hostname.match(/youtube\.com|youtu\.be/)){
            media.contentWindow.postMessage(JSON.stringify({ event:'command', func:'playVideo', args:[] }), '*');
          }else if(src.hostname.match(/vimeo\.com/)){
            media.contentWindow.postMessage(JSON.stringify({ method:'play' }), '*');
          }
        }catch(_){}
      }
      tile.classList.add('is-playing');
    }

    function togglePlay(){
      if(media.tagName === 'VIDEO'){
        if(media.paused){ playMedia(); } else { media.pause(); tile.classList.remove('is-playing'); }
      }else{
        /* For iframes, treat tile click as play */
        playMedia();
      }
    }

    /* Click anywhere on the tile to toggle play/pause */
    tile.addEventListener('click', togglePlay);

    /* Keep state in sync for native videos */
    if(media.tagName === 'VIDEO'){
      media.addEventListener('play', ()=> tile.classList.add('is-playing'));
      media.addEventListener('pause', ()=> tile.classList.remove('is-playing'));
      media.addEventListener('ended', ()=> tile.classList.remove('is-playing'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
